import { useUser } from '@myosh/myosh-login';
import { OdinIcon, OdinIconSize } from '@myosh/odin-components';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import useUserSchemas from '../../../../hooks/use-user-schemas';

const GlobalSearchInput = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state: userState } = useUser();
  const { currentSchema } = useUserSchemas(userState);

  const [searchInput, setSearchInput] = useState('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && searchInput.trim() !== '') {
      navigate(`/${currentSchema?.value}/search/${encodeURIComponent(searchInput.trim())}`);
    }
  };

  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
  }, []);

  const handleClearInput = useCallback(() => {
    setSearchInput('');
  }, []);

  return (
    <div className="relative my-1 h-8 w-full max-w-2xl max-sm:ml-1">
      <div className="border-gray-500 flex h-full items-center rounded border bg-mono-1 px-2 pr-7 text-gray-1">
        <OdinIcon icon="Search" size={OdinIconSize.ExtraSmall} className="text-gray-1" />
        <input
          type="text"
          placeholder={t('search-record')}
          className="ml-2 flex-1 bg-transparent text-sm outline-none sm:w-64"
          onChange={handleInputChange}
          value={searchInput}
          onKeyDown={handleKeyDown}
        />
      </div>

      {searchInput.length > 0 && (
        <span onClick={handleClearInput} className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer">
          <OdinIcon icon="X" size={OdinIconSize.ExtraSmall} className="text-gray-1" />
        </span>
      )}
    </div>
  );
};

export default GlobalSearchInput;
